export enum FormFieldType {
  String = 1,
  Multiline = 2,
  Bool = 3,
  Dimension = 4,
  Int = 5,
  Dropdown = 6,
  Date = 7,
  DateTime = 8,
  CheckboxList = 9,
  HorizontalRule = 10,
  TextboxWithCheckbox = 11
}

export interface LabelConfig {
  x: number;
  y: number;
  width: number;
  height: number;
  fontFamily: string;
  fontSize: number;
  fontColor: string;
  isBold: boolean;
  isItalic: boolean;
  alignment: string; // Horizontal alignment: Left, Center, Right
  verticalAlignment: string; // Vertical alignment: Top, Middle, Bottom
  isVisible: boolean;
}

export interface PdfFieldConfig {
  x: number;
  y: number;
  width: number;
  height: number;
  fontFamily: string;
  fontSize: number;
  fontColor: string;
  tabOrder: number;
  alignment: string;
  isMultiline: boolean;
  isBold: boolean;
  isItalic: boolean;
  pageWidth: number;
  pageHeight: number;
  pageNumber: number;
  labelConfig?: LabelConfig;
}

export interface FormFieldEditorDto {
  id: number;
  formSectionId: number;
  code: string;
  description: string;
  displayOrder: number;
  columnNumber: number;
  fieldType: FormFieldType;
  formFieldDataTypeId?: number;
  info?: string;
  configurationJson?: string;
  pdfConfig?: PdfFieldConfig;
  isRequired: boolean;
  isActive: boolean;
}

export interface SectionPdfConfig {
  x: number;
  y: number;
  width: number;
  height: number;
  borderColor: string;
  borderWidth: number;
  showBorder: boolean;
  pageNumber: number;
}

export interface FormSectionEditorDto {
  id: number;
  formId: number;
  code: string;
  description: string;
  columnNumber: number;
  displayOrder: number;
  isActive: boolean;
  formFields: FormFieldEditorDto[];
  configurationJson?: string;
  pdfConfig?: SectionPdfConfig;
}

export interface FormEditorDto {
  id: number;
  businessId: string;
  code: string;
  description: string;
  displayOrder: number;
  numberOfColumns: number;
  pdfConfigurationJson?: string;
  headerConfigurationJson?: string;
  isActive: boolean;
  isPrintable: boolean;
  formSections: FormSectionEditorDto[];
}

export interface CreateFormFieldEditorDto {
  formSectionId: number;
  code: string;
  description: string;
  displayOrder: number;
  columnNumber: number;
  fieldType: FormFieldType;
  formFieldDataTypeId?: number;
  info?: string;
  isRequired: boolean;
  isActive: boolean;
  configurationJson?: string;
  pdfConfig?: PdfFieldConfig;
}

export interface UpdateFormFieldEditorDto {
  code: string;
  description: string;
  displayOrder: number;
  columnNumber: number;
  fieldType: FormFieldType;
  formFieldDataTypeId?: number;
  info?: string;
  isRequired: boolean;
  isActive: boolean;
  configurationJson?: string;
  pdfConfig?: PdfFieldConfig;
}

export interface GenerateSqlResponse {
  sql: string;
}
